module.exports = __webpack_public_path__ + "static/img/close.48f4336d.svg";